import { SpeakingSlotDto } from 'api/planning';

export const getMinSwaCapacity = (slots: SpeakingSlotDto[]) =>
  Math.max(1, ...slots.map((slot) => slot.plannedCapacity - slot.availableCapacity));
